
import { computed, defineComponent, onBeforeMount, onMounted } from "vue";
import { RouterName } from "@/models/common";
import { AuthActionTypes } from "@/store/modules/auth/actions";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";
import { isActivePath } from "@/router";
import { AuthMutationTypes } from "@/store/modules/auth/mutations";

export default defineComponent({
  name: "Auth Nav",

  setup() {
    const store = useStore();
    const userName = computed(() => store.getters.getAccountInfo?.Name);
    const isSigned = computed(() => {
      return (userName.value?.length || 0) > 0;
    });

    const { t } = useI18n();
    /**
     * logout link path
     */
    const logout = async () => {
      await store.dispatch(AuthActionTypes.SIGNOUT);
    };

    const isActive = (item: string) => {
      return isActivePath(item);
    };

    onBeforeMount(async () => {
      //console.log('onMounted getAccountInfo name => ' + userName.value);
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      const token = params.get("token");
      console.log(token, "<=token");
      const access = localStorage.getItem("access");
      if (token && token.length > 0 && (access || "").length <= 0) {
        store.commit(AuthMutationTypes.SET_TOKEN, token);
        const accoutnInfo = await store.dispatch(AuthActionTypes.GET_ACCOUNT_INFO);
        console.log(accoutnInfo, "<=accoutnInfo");
      }
    });

    onMounted(async () => {});

    return { RouterName, isSigned, name, logout, isActive, t };
  },
  components: {},
});
